import { Text, Primary13Regular, RedRed60 } from '@sequencehq/core-components'
import { toMoney } from '@sequencehq/utils'
import type { Currency } from '@sequencehq/api'

/**
 * Inline hint shown under a credit note line item whose amount exceeds the
 * remaining creditable amount of its invoice line item. Always live (not gated
 * on a submit attempt), matching the aggregate exceedsCreditable error in
 * TotalsSection.
 */
export const ExceedsRemainingHint = ({
  remainingNet,
  currency
}: {
  /**
   * Remaining creditable net for the row's line item; absent when the row is
   * within it (no hint rendered).
   */
  remainingNet?: string
  currency: Currency
}) => {
  if (remainingNet === undefined) {
    return null
  }

  return (
    <Text
      {...Primary13Regular}
      color={RedRed60}
      display="block"
      // The line-items table sets white-space: nowrap and overflow: hidden on
      // every cell, which would clip this message at the description column
      // edge; wrapping keeps the remaining amount visible.
      whiteSpace="normal"
      data-testid="issue-credit-note.lineItem.exceedsRemaining"
    >
      Exceeds remaining creditable amount of{' '}
      {toMoney({ currency, value: remainingNet })}
    </Text>
  )
}
